import type { Questions } from '../Types/Questions'

const questions = {
  onlyNational: {
    koenigin: {
      id: 'koenigin',
      answers: {
        national: 70,
        description: (
          <>
            <p>
              Als die 18-jährige Elizabeth 1952 gekrönt wurde, hätte niemand
              gedacht, dass sie eine Ära prägen wird. Für viele Generationen
              wurde «die Queen» zum Inbegriff der Monarchie. Sie regierte
              unglaubliche 70 Jahre, 7 Monate und 2 Tage lang – und übertraf
              damit ihre Ururgrossmutter Victoria (1837–1901) um 7 Jahre.
            </p>
            <p>
              Umso länger musste ihr Sohn Charles warten, der mittlerweile
              bereits 74-jährig ist und damit älter als alle bisherigen
              britischen Königinnen und Könige bei ihrer Krönung. Um mit seiner
              Mutter gleichzuziehen, müsste Charles bis zu seinem 144.
              Lebensjahr auf dem Thron bleiben.
            </p>
          </>
        ),
      },
      meta: {
        question: 'Wie lange hat Königin Elizabeth II. regiert?',
        description: 'In Jahren',
        unit: 'Jahre',
        min: 10,
        max: 100,
        year: 2021,
        source: [
          {
            sourceTitle: 'Statista',
            sourceUrl:
              'https://www.statista.com/topics/3775/the-british-royal-family/#topicOverview',
          },
          {
            sourceTitle: ', BBC',
            sourceUrl: 'https://www.bbc.com/news/uk-34177107',
          },
        ],
      },
    },
    erbe: {
      id: 'erbe',
      answers: {
        national: 445,
        description: (
          <>
            <p>
              Die Queen soll ein Testament gemacht haben. Was dort festgehalten
              ist, wird man aber erst in 90 Jahren erfahren. So lange wird der
              letzte Wille der Monarchin geheim bleiben. Es wird vermutet, dass
              Charles das Privatvermögen seiner Mutter Elizabeth von geschätzt
              445 Millionen Franken geerbt hat – notabene ohne die in
              Grossbritannien üblichen 40 Prozent Erbschaftssteuer zahlen zu
              müssen, weil die Royals aufgrund einer Vereinbarung seit 1993
              davon befreit sind.
            </p>
            <p>
              Das Privatvermögen besteht unter anderem aus Juwelen, einer Kunst-
              und Briefmarkensammlung, Gestüten und Aktien, dem Schloss Balmoral
              und dem Landsitz Sandringham. Charles erbt auch das Herzogtum
              Lancaster, zu dem Golfplätze, Schlösser und andere Immobilien
              gehören. Es erwirtschaftet jährlich gut 20 Millionen Franken, die
              direkt in den privaten Geldbeutel («Privy Purse») von Charles
              fliessen.
            </p>
          </>
        ),
      },
      meta: {
        question: 'Wie viele Millionen hat Charles von seiner Mutter geerbt?',
        description: 'In Millionen Schweizer Franken',
        unit: 'Mio.',
        min: 0,
        max: 999,
        year: 2021,
        source: [
          {
            sourceTitle: '«Forbes»',
            sourceUrl:
              'https://www.forbes.com/sites/arielshapiro/2021/03/10/inside-the-firm-how-the-royal-familys-28-billion-money-machine-really-works/?sh=188266122bcc',
          },
          {
            sourceTitle: ', «Spiegel»',
            sourceUrl:
              'https://www.spiegel.de/wirtschaft/soziales/queen-elizabeth-ii-einnahmen-durch-herzogtum-lancaster-steigen-a-1045249.html',
          },
        ],
      },
    },
    vermoegen: {
      id: 'vermoegen',
      answers: {
        national: 25,
        description: (
          <>
            <p>
              Das Vermögen, das die Krone im Laufe von etwa 1000 Jahren
              zusammengetragen hat, wird auf umgerechnet 25 Milliarden Franken
              geschätzt. Darin eingeschlossen sind der Buckingham Palace (etwa
              4,4 Milliarden), der Kensington Palace (560 Millionen) und die
              Herzogtümer Cornwall (1,2 Milliarden) und Lancaster (660
              Millionen).
            </p>
            <p>
              Den grössten Teil des Vermögens macht aber der sogenannte Crown
              Estate aus. So heisst die Stiftung, die den Immobilien- und
              Landbesitz der Königsfamilie verwaltet. Ihr gehören unter anderem
              die berühmte Pferderennbahn Ascot und die komplette
              Luxuseinkaufsmeile Regent Street im Herzen von London, aber auch
              Offshore-Windparks vor der Küste, Gemäldesammlungen und
              Einkaufszentren. Der Gesamtwert der Stiftung wird auf umgerechnet
              mehr als 17 Milliarden Franken taxiert.
            </p>
            <p>
              Der «Crown Estate» macht jedes Jahr satte Gewinne, die der Staat
              bekommt. Dieser überweist dann 25 Prozent an den König als
              «Sovereign Grant», eine Art Unterhalt. Dieses Geld wird für
              offizielle Ausgaben verwendet, etwa um die Gehälter der
              Bediensteten zu zahlen, die Schlösser zu unterhalten oder die
              Kosten für Dienstreisen zu decken.
            </p>
          </>
        ),
      },
      meta: {
        question: 'Wie hoch ist das Gesamtvermögen der königlichen Familie?',
        description: 'In Milliarden Schweizer Franken',
        unit: 'Mrd.',
        min: 0,
        max: 30,
        year: 2021,
        source: [
          {
            sourceTitle: '«Forbes»',
            sourceUrl:
              'https://www.forbes.com/sites/arielshapiro/2021/03/10/inside-the-firm-how-the-royal-familys-28-billion-money-machine-really-works/?sh=188266122bcc',
          },
          {
            sourceTitle: ', «Tagesschau»',
            sourceUrl:
              'https://www.tagesschau.de/ausland/europa/grossbritannien-koenigshaus-finanzen-101.html',
          },
        ],
      },
    },
    angestellte: {
      id: 'angestellte',
      answers: {
        national: 1200,
        description: (
          <>
            <p>
              Die königliche Familie hat Tausende Angestellte auf der ganzen
              Welt. Allein im Buckingham Palace, der offiziellen Residenz des
              britischen Monarchen in London, arbeiten etwa 1200 Personen. Sie
              sind für Sicherheit, Kommunikation, Verwaltung, Instandhaltung,
              Tierpflege, Küche, Garderobe, protokollarische Angelegenheiten und
              vieles mehr zuständig.
            </p>
          </>
        ),
      },
      meta: {
        question: 'Wie viele Angestellte arbeiten im Buckingham Palace?',
        description: 'Anzahl Personen',
        image: 'staff',
        imagePosition: 'center',
        unit: 'Personen',
        min: 0,
        max: 5000,
        year: 2021,
        source: [
          {
            sourceTitle: '«Forbes»',
            sourceUrl:
              'https://www.forbes.com/sites/arielshapiro/2021/03/10/inside-the-firm-how-the-royal-familys-28-billion-money-machine-really-works/?sh=188266122bcc',
          },
        ],
      },
    },
    ausgaben: {
      id: 'ausgaben',
      answers: {
        national: 114,
        description: (
          <>
            <p>
              Die britische Königsfamilie gab im Jahr 2020/21 (April bis März)
              insgesamt 102,4 Millionen Pfund Sterling aus, was 114 Millionen
              Franken entspricht. Fast 88 Prozent der Ausgaben entfielen auf die
              Instandhaltung ihres Eigentums und auf die Gehälter der
              Angestellten. Der Rest setzte sich aus verschiedenen,
              vergleichsweise kleinen Posten zusammen. So häuften die Royals zum
              Beispiel Reisekosten in Höhe von 4,5 Millionen Pfund an.
            </p>
            <p>
              In den letzten Jahren sind die Ausgaben deutlich gestiegen. Das
              liegt unter anderem daran, dass der marode Buckingham Palace
              renoviert werden muss. 2017 wurde dafür extra der «Sovereign
              Grant» von 15 auf 25 Prozent aufgestockt. Die Royals erhalten also
              mehr Geld aus dem «Crown Estate» respektive vom Staat, der das
              Geld aus der königlichen Stiftung verwaltet.
            </p>
            <p>
              Was letztlich aus der Kasse des Königs bestritten wird und was aus
              staatlichen Steuergeldern, ist jedoch immer wieder Gegenstand von
              Diskussionen. Monarchiegegner üben Kritik am aufwendigen
              Lebensstil der Royals auf Kosten der Bevölkerung. Unterstützer
              argumentieren, dass die Königsfamilie den Tourismus ankurbelt.
              2017 schätzte das Beratungsunternehmen Brand Finance den Beitrag
              der Monarchie zur britischen Wirtschaft auf rund 1,8 Milliarden
              Pfund pro Jahr.
            </p>
          </>
        ),
      },
      meta: {
        question: 'Wie viel gibt die königliche Familie pro Jahr aus?',
        description: 'In Millionen Schweizer Franken',
        unit: 'Mio.',
        min: 0,
        max: 150,
        year: 2021,
        source: [
          {
            sourceTitle: 'Statista',
            sourceUrl:
              'https://www.statista.com/statistics/372882/uk-royal-family-expenditure-breakdown/',
          },
          {
            sourceTitle: ', «Tagesschau»',
            sourceUrl:
              'https://www.tagesschau.de/ausland/europa/grossbritannien-koenigshaus-finanzen-101.html',
          },
        ],
      },
    },
    merch: {
      id: 'merch',
      answers: {
        national: 17,
        description: (
          <>
            <p>
              Fans der Royals können sich mit jedem erdenklichen
              Merchandise-Artikel eindecken. Der Onlineshop und die
              Touristenläden der königlichen Familie verkaufen eine Palette, die
              von Porzellangeschirr und Schmuck über Picknickdecken bis zu
              selbst hergestelltem Gin aus Pflanzen des Palastgartens reicht.
            </p>
            <p>
              Seit 2009 erwirtschaften die Royals damit 15 Millionen Pfund pro
              Jahr, umgerechnet 17 Millionen Franken. Gedrückt wird dieser
              Schnitt vom Ergebnis der Jahre 2020/21 und 2021/22, als es im Zuge
              der Corona-Pandemie zu einem Umsatzeinbruch kam. Es ist zu
              erwarten, dass die Krönung von Charles den Souvenirverkauf wieder
              ankurbeln wird.
            </p>
          </>
        ),
      },
      meta: {
        question:
          'Wie viel verdienen die Royals jährlich mit dem Verkauf von Souvenirs?',
        description: 'In Millionen Schweizer Franken',
        unit: 'Mio.',
        min: 0,
        max: 30,
        year: 2021,
        source: [
          {
            sourceTitle: 'Royal Collection Trust',
            sourceUrl:
              'https://www.rct.uk/sites/default/files/resources/Annual%20Report%202021-22.pdf',
          },
          {
            sourceTitle: ', Royal Collection Shop',
            sourceUrl: 'https://www.royalcollectionshop.co.uk/',
          },
          {
            sourceTitle: ', «Frankfurter Allgemeine Zeitung»',
            sourceUrl:
              'https://www.faz.net/aktuell/wirtschaft/schneller-schlau/kroenung-von-charles-iii-vermoegen-der-royals-im-buckingham-palace-18850252.html',
          },
        ],
      },
    },
    touristen: {
      id: 'touristen',
      answers: {
        national: 2,
        description: (
          <>
            <p>
              Auch die Zahl der Besucher königlicher Residenzen in
              Grossbritannien ging während der Pandemie stark zurück. Vor Corona
              verkauften die Royals jährlich über 3 Millionen Eintritte, 2020/21
              waren es nur noch 155’000 und im vergangenen Jahr immerhin wieder
              737’000. Der Schnitt der letzten Jahre liegt somit bei 2 Millionen
              Touristinnen und Touristen.
            </p>
            <p>
              Am liebsten besuchen diese übrigens nicht den Buckingham Palace.
              Das Schloss Windsor und der Holyrood Palace im schottischen
              Edinburgh sind noch beliebtere Sehenswürdigkeiten. In den Jahren
              vor der Pandemie erwirtschaftete der königliche Tourismus allein
              durch den Verkauf von Eintrittskarten über 70 Millionen Pfund.
            </p>
          </>
        ),
      },
      meta: {
        question:
          'Wie viele Touristen besuchen jährlich die königlichen Residenzen?',
        description: 'In Millionen',
        unit: 'Mio.',
        min: 0,
        max: 10,
        year: 2021,
        source: [
          {
            sourceTitle: 'Royal Collection Trust',
            sourceUrl:
              'https://www.rct.uk/sites/default/files/resources/Annual%20Report%202021-22.pdf',
          },
        ],
      },
    },
    kunst: {
      id: 'kunst',
      answers: {
        national: 1000000,
        description: (
          <>
            <p>
              Die Kunstsammlung der königlichen Familie umfasst eine Million
              Objekte. In einer Onlinedatenbank können fast 270’000 von ihnen
              durchsucht werden. Darunter befinden sich Werke von Künstlern wie
              Rembrandt, Vermeer und Van Dyck, aber auch Kuriositäten wie die
              Miniatur einer Nestlé-Kondensmilchdose aus dem Puppenhaus von
              Königin Mary oder eine Zeichnung der Jungfrau, die Königin
              Victoria während ihres Aufenthalts in Luzern im Jahr 1868
              angefertigt hat.
            </p>
          </>
        ),
      },
      meta: {
        question: 'Wie viele Objekte enthält die königliche Kunstsammlung?',
        description: null,
        image: 'art',
        imagePosition: 'center',
        unit: 'Objekte',
        min: 0,
        max: 1250000,
        year: 2021,
        source: [
          {
            sourceTitle: 'Royal Collection Trust',
            sourceUrl: 'https://www.royalcollection.org.uk/collection/about',
          },
        ],
      },
    },
    schule: {
      id: 'schule',
      answers: {
        national: 8,
        description: (
          <>
            <p>
              Charles war der erste britische Thronfolger, der auch ausserhalb
              der Palastmauern unterrichtet wurde. Eine Woche vor seinem achten
              Geburtstag, am 7. November 1956, wurde er in der Hill House School
              unweit des Buckingham Palace eingeschult. Hier verbrachte er aber
              nur knapp ein Jahr, bevor er ins Elite-Internat Cheam wechselte,
              das schon sein Vater besucht hatte. Später studierte Charles an
              der Universität von Cambridge Archäologie und Anthropologie.
            </p>
          </>
        ),
      },
      meta: {
        question: 'Wie alt war Charles, als er eingeschult wurde?',
        description: 'Alter in Jahren',
        unit: 'Jahre',
        min: 0,
        max: 15,
        year: 2021,
        source: [
          {
            sourceTitle: 'AP',
            sourceUrl:
              'https://apnews.com/article/coronation-king-charles-iii-first-school-d68b601b6d5abe4ae6bec5ee96652503',
          },
          {
            sourceTitle: ', Royal Collection Trust',
            sourceUrl:
              'https://www.rct.uk/collection/2813870/prince-charles-receives-his-ma-degree-from-cambridge',
          },
        ],
      },
    },
    auto: {
      id: 'auto',
      answers: {
        national: 0,
        description: (
          <>
            <p>
              Kein einziges Mal. Denn die Queen hatte keinen Führerschein und
              musste auch nie eine Fahrprüfung ablegen. Nach britischem Recht
              war die Monarchin von dieser Pflicht befreit, da die Führerscheine
              auf ihren Namen ausgestellt wurden. Dieses Privileg, das für
              andere Mitglieder der königlichen Familie nicht gilt, wurde nun
              auch auf Charles ausgeweitet.
            </p>
            <p>
              Übrigens kannte sich Elizabeth II. trotzdem sehr gut mit Autos
              aus: Während des Zweiten Weltkrieges meldete sie sich freiwillig
              beim Frauenzweig der britischen Armee und wurde als Fahrerin und
              Mechanikerin ausgebildet.
            </p>
          </>
        ),
      },
      meta: {
        question:
          'Wie oft wurde Königin Elizabeth beim Fahren ohne Führerschein erwischt?',
        description: 'Male',
        unit: 'Mal',
        min: 0,
        max: 42,
        year: 2021,
        source: [
          {
            sourceTitle: 'Express',
            sourceUrl:
              'https://www.express.co.uk/news/royal/1515081/queen-elizabeth-II-driving-licence-evg',
          },
          {
            sourceTitle: ', National WW2 Museum',
            sourceUrl:
              'https://www.nationalww2museum.org/war/articles/queen-elizabeth-ii-during-world-war-ii',
          },
        ],
      },
    },
    follower: {
      id: 'follower',
      answers: {
        national: 1,
        description: (
          <>
            <p>
              Gar nicht so viele wie vielleicht gedacht. Dem offiziellen Kanal
              der britischen Monarchie folgen 1,13 Millionen Menschen. Er wurde
              2007 von Elizabeth II. selbst ins Leben gerufen, um die britische
              Monarchie zu fördern. Es waren die Enkelinnen der Queen, die
              Prinzessinnen Beatrice und Eugenie, die ihr die
              Video-Sharing-Website erklärten. Auf «Royal Family» werden etwa
              Aufnahmen von Reden, Staatsbesuchen und königlichen Hochzeiten
              geteilt.
            </p>
            <p>
              Boulervardesker geht es auf anderen Youtube-Kanälen zu, die sich
              dem Leben der königlichen Familie verschrieben haben. Der «Royal
              Family Channel» zum Beispiel zeigt Charles im Badeanzug, Prinz
              William als spontanen Restaurantmitarbeiter oder Diana, die mit
              den Kindern spielt, als die noch Babys sind. Der Kanal hat über 3
              Millionen Follower und damit fünfmal mehr als derjenige, den Prinz
              William und seine Frau Kate 2020 selbst starteten.
            </p>
          </>
        ),
      },
      meta: {
        question:
          'Wie viele Follower hat der Youtube-Kanal der königlichen Familie?',
        description: 'In Millionen',
        unit: 'Mio.',
        min: 0,
        max: 20,
        year: 2021,
        source: [
          {
            sourceTitle: '«Royal Family»',
            sourceUrl: 'https://www.youtube.com/user/theroyalchannel',
          },
          {
            sourceTitle: ', «Royal Family Channel»»',
            sourceUrl: 'https://www.youtube.com/@royalchannel/featured',
          },
          {
            sourceTitle: ', «The Prince and Princess of Wales»',
            sourceUrl: 'https://www.youtube.com/@princeandprincessofwales',
          },
        ],
      },
    },
    pferde: {
      id: 'pferde',
      answers: {
        national: 6,
        description: (
          <>
            <p>
              König Charles III. wird mit der Diamond Jubilee State Coach zu
              seiner Krönungszeremonie in der Westminster Abbey gefahren. Dabei
              handelt es sich um eine moderne Kutsche, die erst 2014 zum
              diamantenen Thronjubiläum von Elizabeth II. in Betrieb ging und
              von 6 Pferden gezogen wird. Sie verfügt über elektrische
              Fensterheber, sechsfache Federung, Heizung und Klimaanlage.
            </p>
            <p>
              Weniger komfortabel wird es auf dem Rückweg. Um die
              Traditionalisten nicht zu verägern, steigt Charles dann auf die
              260 Jahre alte Golden State Coach um, die als äusserst unbequem
              gilt. Die Kutsche kam seit 1831 aber bei jeder Krönung einer
              britischen Monarchin oder eines Monarchen zum Einsatz. Sie ist
              vergoldet, wiegt vier Tonnen und braucht sogar acht Pferde, um sie
              zu ziehen.
            </p>
          </>
        ),
      },
      meta: {
        question: 'Wie viele Pferde ziehen Charles’ Kutsche zur Krönung?',
        description: null,
        image: 'chevaux',
        imagePosition: '30%',
        unit: 'Pferde',
        min: 0,
        max: 10,
        year: 2021,
        source: [
          {
            sourceTitle: 'Royal Collection Trust',
            sourceUrl:
              'https://www.rct.uk/visit/the-royal-mews-buckingham-palace',
          },
          {
            sourceTitle: ', Deutsche Welle',
            sourceUrl:
              'https://www.dw.com/de/charles-goldene-kutsche-kr%C3%B6nung/a-65276841',
          },
        ],
      },
    },
    juwelen: {
      id: 'juwelen',
      answers: {
        national: 23578,
        description: (
          <>
            <p>
              Die britischen Kronjuwelen, die im Tower of London aufbewahrt
              werden, gelten als die wertvollste Sammlung von Diamanten und
              Juwelen überhaupt. Dazu gehören unter anderem verschiedene Kronen,
              Zepter, Schwerter, Ringe und Kleidungsstücke wie die königliche
              Robe. Insgesamt enthalten die Kronjuwelen, die nur zu besonderen
              Anlässen getragen werden, 23’578 Edelsteine.
            </p>
            <p>
              Das Zepter des Herrschers mit Kreuz, das Charles bei seiner
              Krönung halten wird, ist mit dem Cullinan-I-Diamanten verziert. Er
              gilt als weltweit grösster geschliffener weisser Diamant von
              höchster Qualität und wiegt 530 Karat. Im Jahr 1908 wurde der
              Stein auf 2,5 Millionen US-Dollar geschätzt (was heute 55
              Millionen US-Dollar entspricht), aber diese Schätzung liegt
              wahrscheinlich immer noch weit unter dem Preis, den der Stein
              erzielen würde, wenn er verkauft werden müsste – was natürlich
              unvorstellbar ist.
            </p>
          </>
        ),
      },
      meta: {
        question: 'Wie viele Edelsteine enthalten die Kronjuwelen?',
        description: null,
        unit: 'Steine',
        min: 0,
        max: 30000,
        year: 2021,
        source: [
          {
            sourceTitle: 'Royal Collection Trust',
            sourceUrl:
              'https://www.rct.uk/collection/themes/Trails/the-crown-jewels',
          },
        ],
      },
    },
  },
}

export default questions as unknown as Questions
